import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

export default function AdminGate() {
  return localStorage.getItem("samatva_admin_token") ? (
    <AdminDashboard />
  ) : (
    <AdminLogin />
  );
}
